import {
  domToReact,
  type DOMNode,
  type HTMLReactParserOptions,
} from "html-react-parser"

type ReplaceHandler = NonNullable<HTMLReactParserOptions["replace"]>
type ParserElementNode = DOMNode & {
  attribs?: Record<string, string>
  children?: DOMNode[]
  name?: string
  type?: string
}

export const isParserElementNode = (
  domNode: DOMNode
): domNode is ParserElementNode =>
  typeof domNode === "object" &&
  domNode !== null &&
  "type" in domNode &&
  domNode.type === "tag"

export const getSafeHtmlParserOptions = (
  replace?: ReplaceHandler
): HTMLReactParserOptions => ({
  // Use the lighter htmlparser2 backend (default in html-react-parser) instead
  // of parse5. Drops ~517 KB from the client bundle and is sufficient for the
  // SVG / fragment payloads served by the CMS.
  htmlparser2: {
    lowerCaseAttributeNames: false,
  },
  replace: (domNode: DOMNode, index: number) => {
    if (isParserElementNode(domNode)) {
      if (domNode.name === "script") {
        return <template data-ignored-script="" />
      }

      // Some CMS / SVG payloads arrive wrapped in full document tags.
      // Unwrap them so we never try to hydrate nested <html>/<body>/<head> nodes.
      if (domNode.name && ["html", "body", "head"].includes(domNode.name)) {
        return (
          <>
            {domToReact(
              domNode.children as DOMNode[],
              getSafeHtmlParserOptions(replace)
            )}
          </>
        )
      }
    }

    return replace?.(domNode, index)
  },
})
